import { useCallback, useRef, useState } from 'react'

const THREE_COLUMNS_MIN_WIDTH = 940

const useClientTabColumns = (enabled: boolean) => {
  const [columns, setColumns] = useState(3)
  const observer = useRef<ResizeObserver | null>(null)

  const columnsRef = useCallback(
    (element: HTMLDivElement | null) => {
      observer.current?.disconnect()
      observer.current = null
      if (!enabled || !element) return

      observer.current = new ResizeObserver(([entry]) => {
        setColumns(entry.contentRect.width >= THREE_COLUMNS_MIN_WIDTH ? 3 : 2)
      })
      observer.current.observe(element)
    },
    [enabled],
  )

  return { columnsRef, columns }
}

export default useClientTabColumns
